// ─── Les TUNNELS de Gively — source unique ───────────────────────────────────
//
// Cette liste vivait dans `components/PWAInstallPrompt.js`, et c'était un
// mauvais domicile pour deux raisons découvertes le 23/09/2026 :
//
//  1. ELLE NE SERVAIT QU'À UNE BANNIÈRE SUR DEUX. `components/CookieConsent.js`
//     souffrait exactement du défaut qu'elle corrige — il est `fixed bottom-0`
//     en z-index 9999, la barre d'action du tunnel de publication est
//     `fixed bottom-0` en z-index 1000 (`pages/publish/components/PublishCTA.js:59-63`),
//     et 9999 gagne : « Continuer », « Publier » et « Retour » disparaissaient
//     sous le bandeau cookies. Une garde qui n'existe que dans un fichier ne
//     garde que ce fichier.
//
//  2. LE MODULE QUI L'HÉBERGEAIT A UN EFFET DE BORD AU CHARGEMENT :
//     `PWAInstallPrompt.js` fait `document.head.appendChild(style)` au niveau
//     module. Importer un COMPOSANT pour lire une CONSTANTE, c'est hériter de
//     son effet de bord. Une liste de chemins n'a pas à traîner un <style>.
//
// `PWAInstallPrompt` ré-exporte ces deux symboles : ses consommateurs et son
// test (`components/__tests__/pwaInstallPromptTunnels.test.js`) sont inchangés.

export const TUNNEL_PATH_PREFIXES = [
  "/publish",         // tunnel de publication (Phoenix par défaut + legacy)
  "/publish-phoenix", // alias direct du wizard Phoenix
  "/checkout",        // tunnel d'achat
  "/payment",         // pages de paiement (Stripe)
  "/onboarding",      // onboarding utilisateur
  "/association",     // espace asso complet : register, login, dashboard (checklist d'onboarding)
  "/login",
  "/register",
];

/** Le pathname est-il dans un tunnel où la bannière ne doit jamais s'auto-afficher ?
 *  Sémantique de SEGMENT (t exact ou t/...) : une page dont le nom ne fait que
 *  COMMENCER par un mot de la liste (ex. /checkout-guide) n'est pas avalée. */
export function isTunnelPath(pathname) {
  const p = typeof pathname === "string" ? pathname : "";
  return TUNNEL_PATH_PREFIXES.some((t) => p === t || p.startsWith(t + "/"));
}
